// extracted by mini-css-extract-plugin
export default {"wrapper":"DlGPMKE5AoCGWcm7YIz8","title":"Tgph56OyA6q8xx1m43xR"};